import { Calendar } from "primereact/calendar"
import { Dropdown } from "primereact/dropdown"
import { FileUpload, FileUploadHeaderTemplateOptions, FileUploadSelectEvent, FileUploadUploadEvent, ItemTemplateOptions } from "primereact/fileupload"
import { InputMask } from "primereact/inputmask"
import { Splitter, SplitterPanel } from "primereact/splitter"
import { Tooltip } from "primereact/tooltip"
import { useEffect, useRef, useState } from "react"
import { MdDomain, MdGroups } from "react-icons/md"
import { ProgressBar } from "primereact/progressbar"
import { PiFarmFill } from "react-icons/pi"
import { TIPO_MASK } from "../Login"
import BadgeIcon from '@mui/icons-material/Badge';
import EventIcon from '@mui/icons-material/Event';
import InsertDriveFile from "@mui/icons-material/InsertDriveFile"
import { Button } from "primereact/button"
import { Tag } from "primereact/tag"
import * as mapas from "../../utils/mapas"
import API from '../../api/API'
import { LoteType, ImovelType } from "../../db/Orm"
import InputCpfCnpj from "./InputCpfCnpj"
import { Nullable } from "primereact/ts-helpers"

type LotesAccordionTabProps = {
    lotes: Array<any>,
    setCount: Function,
    propriedades: Array<ImovelType>,
    arrendatario: any,
    setArrendatario: Function,
    dataInicioArrendamento: Nullable<Date>,
    setDataInicioArrendamento: Function,
    dataFinalArrendamento: Nullable<Date>,
    setDataFinalArrendamento: Function,
    setContrato: Function
}
// } & AccordionTabProps

export const LotesAccordionTab = (props: LotesAccordionTabProps) => {
    // export const LotesAccordionTab: FunctionComponent<LotesAccordionTabProps> = ({ children, ...props }) => {
    // export const createLotesAccordionTab = (props: LotesAccordionTabProps): JSX.Element => {
    const [propriedade, setPropriedade] = useState<any>(null)
    const [propriedades, setPropriedadess] = useState<Array<ImovelType>>(props.propriedades || [])
    const [loading, setLoading] = useState<boolean>(false)
    const mapRef = useRef<any>()
    const [map, setMap] = useState<any>(null)

    useEffect(() => {
        try {
            if (mapRef.current) {
                if (mapRef.current && !map) {
                    const map = mapas.createMapOnBahia(mapRef)
                    mapas.refreshingMap(map, setLoading)
                    setMap(map)
                }
                setTimeout(() => {
                }, 1); // Pequeno atraso para garantir que o Dialog esteja completamente renderizado
            }

            // return () => {
            //     if (mapa) {
            //         selectLotesMap.current.remove(); // Limpa o mapa quando o Dialog é fechado ou o componente desmontado
            //         setMapa(null);
            //     }
            // };
        } catch (e: any) { console.log('Error:', e) }
    }, [mapRef.current]);
    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    const [files, setFiles] = useState<Array<any>>([])
    const [totalSizes, setTotalSizes] = useState<Array<any>>([])
    const onTemplateSelect = (e: FileUploadSelectEvent, f: number) => {
        totalSizes[f - 1] = e.files[0].size
        files[f - 1] = e.files[0]
        props.setContrato(e.files[0])
    };

    const onTemplateUpload = (e: FileUploadUploadEvent, f: number) => {
        totalSizes[f - 1] = e.files[0].size
        // toast.current?.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };

    const onTemplateRemove = (file: File, callback: Function, f: number) => {
        console.log('File:', file, 'Callback:', callback, 'F:', f)
        totalSizes[f - 1] = 0
        if (callback) callback();
    };

    const onTemplateClear = (f: number) => {
        totalSizes[f - 1] = 0
        setFiles([])
        props.setContrato(null)
    };
    const fileUploadRef0 = useRef<FileUpload>(null);
    
    const headerTemplate1 = (options: FileUploadHeaderTemplateOptions, f: number) => {
        // console.log('Options:', options, 'F:', f)

        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSizes[f - 1] / 30000;
        var formatedValue
        if (f === 1)
            formatedValue = fileUploadRef0 && fileUploadRef0.current ? fileUploadRef0.current.formatSize(totalSizes[f - 1]) : '0 B';
        
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <InsertDriveFile /><b>Contrato de Arrendamento</b>
                </div>
                <div style={{ display: 'flex', justifyItems: 'end' }}>
                    {chooseButton}
                    {/* {uploadButton} */}
                    {cancelButton}
                    <div className="flex align-items-center gap-3 ml-auto">
                        <span>{formatedValue} / 3 MB</span>
                        <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                    </div>
                </div>
            </div>
        );
    };
    const headerTemplate2 = (options: FileUploadHeaderTemplateOptions, f: number) => {
        // console.log('Options:', options, 'F:', f)

        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSizes[f - 1] / 30000;
        var formatedValue
        if (f === 1)
            formatedValue = fileUploadRef0 && fileUploadRef0.current ? fileUploadRef0.current.formatSize(totalSizes[f - 1]) : '0 B';
        
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <InsertDriveFile /><b>Documento de Responsabilidade Técnica</b>
                </div>
                <div style={{ display: 'flex', justifyItems: 'end' }}>
                    {chooseButton}
                    {/* {uploadButton} */}
                    {cancelButton}
                    <div className="flex align-items-center gap-3 ml-auto">
                        <span>{formatedValue} / 3 MB</span>
                        <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                    </div>
                </div>
            </div>
        );
    };
    const itemTemplate = (file: any, props: ItemTemplateOptions, f: number) => {
        // console.log('File in ItemTemplate():', file)
        // const file = files[f]
        if (file)
            return (
                <div className="flex align-items-center flex-wrap">
                    <div className="flex align-items-center" style={{ width: '40%' }}>
                        <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
                        <span className="flex flex-column text-left ml-3">
                            {file.name}
                            <small>{new Date().toLocaleDateString()}</small>
                        </span>
                    </div>
                    <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                    <Button visible={false} type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove, f)} />
                </div>
            );
    };

    const emptyTemplate = (e: any, f: number) => {
        const a: any = ''
        // console.log('Files:', files)
        // console.log('F:', f)
        // console.log('File (' + f + '):', files[f - 1])
        if (files[f - 1] !== null)
            return itemTemplate(files[f - 1], a, f)
        return (
            <div className="flex align-items-center flex-column" style={{ textAlign: 'center' }}>
                <i className="pi pi-image mt-3 p-5" style={{
                    fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)',
                    // width: '100%', height: '100%'
                }}></i>
                <br></br>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Arraste e solte aqui
                </span>
            </div>
        );
    };
    const [lotes2, setLotes2] = useState<Array<any>>([])
    const selectLote = (index: number, lote: LoteType, polygon: any) => {
        if (lotes2.length > 0) {
            if (lotes2[index].color === mapas.estiloSelected.fillColor) {
                props.lotes.splice(props.lotes.indexOf(lote), 1)
                polygon.setStyle(mapas.estiloArea)
                lotes2[index].color = mapas.estiloArea.fillColor
            }
            else {
                polygon.setStyle(mapas.estiloSelected)
                lotes2[index].color = mapas.estiloSelected.fillColor
                props.lotes.push(lote)
            }
        }
        props.setCount(props.lotes.length)
    }
    const carregarPropriedade = async () => {
        if (propriedade) {
            mapas.clearMap(map)
            props.setCount(0)
            props.lotes.splice(0, props.lotes.length)
            const polig = await mapas.carregarZipFromURL(propriedade.poligono, mapas.estiloContorno)
            if (map && polig) {
                polig.addTo(map)
                map?.flyToBounds(polig.getBounds())
                console.log('URL    :', API.url + 'lotes/?propriedade=' + propriedade.id)
                const data = (await API.getData(API.url + 'lotes/?propriedade=' + propriedade.id, null, () => console.log('Error')))
                console.log('Lotes:', data)
                lotes2.splice(0, lotes2.length);
                data.map(async (lote: any, index: number) => {
                    const p = await mapas.carregarZipFromURL(lote.poligono, mapas.estiloArea)
                    p.addTo(map)
                    p.on('click', async () => { selectLote(index, lote, await p) })
                    lotes2.push({ index: index, lote: lote, poligono: await p, color: mapas.estiloArea.fillColor })
                });
            }
        }
    }
    useEffect(() => {
        carregarPropriedade()
        map?.invalidateSize();
    }, [propriedade])
    return (
        <Splitter>
            <SplitterPanel className="flex align-items-center justify-content-center" style={{ flexDirection: 'column' }}>
                <div className="flex flex-column p-inputgroup flex-1">
                    <span className="p-inputgroup-addon"><div style={{ display: 'flex', alignItems: 'center', marginLeft: 10, marginRight: 10 }}><PiFarmFill /><b style={{ paddingLeft: 1 }}>Propriedade</b></div></span>
                    <span className="p-float-label">
                        <Dropdown name='propriedade' value={propriedade} onChange={(e) => setPropriedade(e.value)}
                            options={propriedades} optionLabel="nome" placeholder='Propriedade *' filter >{loading && <ProgressBar mode='indeterminate' />}</Dropdown>
                        <label htmlFor="propriedade">Selecione a propriedade</label>
                    </span>
                </div>
                <div ref={mapRef} style={{ width: '100%', height: '100%', backgroundColor: 'gray' }} />
            </SplitterPanel>
            <SplitterPanel className="flex align-items-center justify-content-center" style={{ flexDirection: 'column' }}>
                <InputCpfCnpj value={props.arrendatario} setValue={props.setArrendatario} label="Arrendatário"
                labelIcon={<BadgeIcon />} />
                <div style={{ height: 5 }} />
                <div className="flex flex-column p-inputgroup flex-1">
                    <span className="p-inputgroup-addon"> <EventIcon /> <b>Inicio do Arrendamento</b></span>
                    <Calendar name='arrendamento_inicio' inputId='data' dateFormat={'dd/mm/yy'} value={props.dataInicioArrendamento} onChange={e => props.setDataInicioArrendamento(e.value)} showIcon />
                </div>
                <div style={{ height: 5 }} />
                <div className="flex flex-column p-inputgroup flex-1">
                    <span className="p-inputgroup-addon"> <EventIcon /> <b>Final do Arrendamento</b></span>
                    <Calendar name='arrendamento_final' inputId='data' dateFormat={'dd/mm/yy'} value={props.dataFinalArrendamento} onChange={e => props.setDataFinalArrendamento(e.value)} showIcon />
                </div>
                <div style={{ height: 5 }} />
                <Tooltip target=".custom-choose-btn" content="Selecionar arquivo" position="bottom" />
                <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />
                <FileUpload ref={fileUploadRef0} name="doc_cpf" url="/api/upload" accept="image/*" maxFileSize={30000000}
                    onUpload={(e) => onTemplateUpload(e, 2)} onSelect={(e) => onTemplateSelect(e, 2)} onError={() => onTemplateClear(2)} onClear={() => onTemplateClear(2)}
                    headerTemplate={(e) => headerTemplate1(e, 2)} itemTemplate={(e, f) => itemTemplate(files[1], f, 2)} emptyTemplate={(e) => emptyTemplate(e, 2)}
                    chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                <div style={{ height: 5 }} />
            </SplitterPanel>
        </Splitter>
    )
}